export default [
  {
    id: 'roles/terraform.legacy-workspace-access-admin',
    version: 0,
    title: 'Terraform Workspace Access Admin',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-access-admin'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-runs-apply',
    version: 0,
    title: 'Terraform Workspace Runs Apply',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-runs-apply'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-runs-plan',
    version: 0,
    title: 'Terraform Workspace Runs Plan',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-runs-plan'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-runs-read',
    version: 0,
    title: 'Terraform Workspace Runs Read',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-runs-read'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-run-tasks-manage',
    version: 0,
    title: 'Terraform Workspace Run Tasks Manage',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-run-tasks-manage'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-sentinel-mocks-read',
    version: 0,
    title: 'Terraform Workspace Sentinel Mocks Read',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-sentinel-mocks-read'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-state-versions-read',
    version: 0,
    title: 'Terraform Workspace State Versions Read',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-state-versions-read'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-state-versions-read-outputs',
    version: 0,
    title: 'Terraform Workspace State Versions Read Outputs',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-state-versions-read-outputs'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-state-versions-write',
    version: 0,
    title: 'Terraform Workspace State Versions Write',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-state-versions-write'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-variables-read',
    version: 0,
    title: 'Terraform Workspace Variables Read',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-variables-read'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-variables-write',
    version: 0,
    title: 'Terraform Workspace Variables Write',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-variables-write'],
    lowest_applicable_resource_types: [],
  },
  {
    id: 'roles/terraform.legacy-workspace-workspaces-lock',
    version: 0,
    title: 'Terraform Workspace Workspaces Lock',
    description: 'Lorem ipsum',
    permissions: ['terraform.legacy.workspace-workspaces-lock'],
    lowest_applicable_resource_types: [],
  },
];
